import { Form, Button, Alert } from 'react-bootstrap';
import React, { useState, useMemo } from 'react';
import { connect } from 'react-redux';
import axiosInstance from '../general/axiosInstance';
import { setIsLoading } from '../general/actions';
import AlertModal from '../general/alertModal';
import { Link } from 'react-router-dom';
import logo from '../../images/logo.png';

// Dominios cuyo servidor de correo bloquea nuestros envíos (medida temporal).
const BLOCKED_EMAIL_DOMAINS = ['medellin.gov.co'];
const SUPPORT_PHONE = '3002050906';

const isBlockedDomain = (email) => {
    const domain = email.trim().toLowerCase().split('@')[1];
    if (!domain) return false;
    return BLOCKED_EMAIL_DOMAINS.some((d) => domain === d || domain.endsWith(`.${d}`));
};

function RecoverPassword(props) {
    const { setIsLoading } = props;
    const [email, setEmail] = useState('');
    const [alertModalShow, setAlertModalShow] = useState(false);
    const [alertModalMsg, setAlertModalMsg] = useState('');
    const [alertModalType, setAlertModalType] = useState('');
    const showDomainWarning = useMemo(() => isBlockedDomain(email), [email]);

    const recoverPassword = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            await axiosInstance.post('/password/recover', { email });
            setAlertModalShow(true);
            setAlertModalMsg('Si estás registrado recibirás un email para asignar una nueva contraseña.');
            setAlertModalType(null);
        } catch (error) {
            setAlertModalShow(true);
            setAlertModalType('danger');
            setAlertModalMsg('No pudimos conectar con el servidor. Verifica el email ingresado e intenta de nuevo.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-card">
                <div className="auth-logo">
                    <img src={logo} height="44" alt="Abi" className="rounded" />
                </div>
                <div className="auth-title">Recuperar contraseña</div>
                <div className="auth-subtitle">
                    Te enviaremos un enlace para restablecer tu contraseña
                </div>

                <Form onSubmit={recoverPassword}>
                    <Form.Group className="mb-4">
                        <Form.Label className="report-field-label">Correo electrónico</Form.Label>
                        <div className="auth-input-wrap">
                            <i className="fa fa-envelope auth-input-icon" />
                            <Form.Control
                                type="email"
                                required
                                placeholder="correo@entidad.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>
                    </Form.Group>

                    {showDomainWarning && (
                        <Alert variant="warning" className="mb-4" role="alert" style={{ fontSize: 13 }}>
                            <i className="fa fa-exclamation-triangle" />{' '}
                            <strong>Estamos presentando un problema</strong> con el envío de correos a cuentas
                            de <strong>medellin.gov.co</strong>, por lo que es posible que no recibas el enlace.
                            Para restablecer tu contraseña comunícate al{' '}
                            <a href={`tel:+57${SUPPORT_PHONE}`}>300 205 0906</a> o escríbenos por{' '}
                            <a href={`https://wa.me/57${SUPPORT_PHONE}`} target="_blank" rel="noopener noreferrer">
                                WhatsApp
                            </a>.
                        </Alert>
                    )}

                    <Button variant="primary" type="submit" disabled={!email} className="w-100 auth-submit-btn">
                        <i className="fa fa-paper-plane" /> Enviar enlace
                    </Button>
                </Form>

                <div style={{ textAlign: 'center', marginTop: 16 }}>
                    <Link to="/login" style={{ color: 'var(--abi-muted)', fontSize: 13 }}>
                        ← Volver al inicio de sesión
                    </Link>
                </div>
            </div>

            <AlertModal
                show={alertModalShow} setShow={setAlertModalShow}
                msg={alertModalMsg} setMsg={setAlertModalMsg}
                variant={alertModalType}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return { isLoading: state.isLoading };
}

const mapDispatchToProps = { setIsLoading };

export default connect(mapStateToProps, mapDispatchToProps)(RecoverPassword);
